import React, {useState} from 'react';
import inputStyles from '../program-management/ProgramManagement.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { setQuestionnaire, removeQuestionnaire, setFormValue } from './PatientEnrollmentSlice';
import ManagementDropdownCard from '../../components/ManagementDropdownCard';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { getInitialStartTime, initSelectedQuestionnaires } from '../../utils/programUtils';

const QuestionnaireEnrollment = ({errors}) => {

    const {reenrolling, viewing, enrollment} = useSelector((state)=>state.enrollPatientProgram);
    const allQuestionnaires = useSelector((state)=>state.enrollmentLists.questionnaires); // all available questionnaires
    const filteredQuestionnaires = allQuestionnaires.filter((questionnaire)=> enrollment.groups.some((group)=> group.groupId === questionnaire.groupId));
    const questionnaireNotes = useSelector((state)=>state.enrollPatientProgram.questionnaireNotes);
    const dispatch = useDispatch();
    const enrollmentQuestionnaires = useSelector((state)=>state.enrollPatientProgram.questionnaires); // all questionnaires in program/enrollment
    const [count, setCount] = useState(0);

    const [selectedQuestionnaires, setSelectedQuestionnaires] = useState(initSelectedQuestionnaires(enrollmentQuestionnaires, allQuestionnaires));
    
    const checkSelectedItem = (id) => {
        let qInList = false;
        selectedQuestionnaires.forEach((item)=>{
            if (item.questionnaireId===id){
                qInList=true;
            } 
        });
        return qInList;
    };

    const handleQuestionnaireChange = (q) => {
        let qInList = false;
        selectedQuestionnaires.forEach((item)=>{
            if (item.questionnaireId===q.questionnaireId){
                qInList = true;
            } 
        });
        if (qInList){
            setSelectedQuestionnaires(selectedQuestionnaires.filter(item => item.questionnaireId !== q.questionnaireId));
            dispatch(removeQuestionnaire(q.questionnaireId))
        } else {
            setSelectedQuestionnaires([q, ...selectedQuestionnaires]);
            let id = q.questionnaireId;
            let questionnaireName = q.name;
            dispatch(setQuestionnaire(
                {
                    id, 
                    questionnaireName,
                    startTime: getInitialStartTime(),
                    frequency: 1,
                    interval: "Day"
                }
            ))
        }
    };

    const removeQuestionnaireCard = (id) => {
        setSelectedQuestionnaires(selectedQuestionnaires.filter(item => item.questionnaireId !== id));
        dispatch(removeQuestionnaire(id));
    };

    const handleNotes = (e) => {
        setCount(e.target.value.length);
        dispatch(setFormValue({key:"questionnaireNotes",value:e.target.value}));
    };

    return (
        <div style={{display:"flex", flexDirection:"column", gap:"10px",paddingBottom:"10px" }}>
            <MultiSelectDropdown 
                options={filteredQuestionnaires}
                label='name'
                checkedKey='questionnaireId'
                checkSelectedItem={checkSelectedItem}
                handleChange={handleQuestionnaireChange}
                selectedItems={selectedQuestionnaires}
                name='Questionnaires'
                disabled={reenrolling || viewing}
            />
            <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
                {selectedQuestionnaires.map((q, index) => (
                    <div key={q.questionnaireId}>
                        <ManagementDropdownCard 
                            open={index!==0 ? false : true} 
                            cardInfo={{title:q.name, id:q.questionnaireId, type:"Questionnaire"}}
                            updateHandler={setQuestionnaire}
                            removeHandler={removeQuestionnaireCard}
                            dataList={enrollmentQuestionnaires}
                            errorShowing={errors.showing}
                            disabled={reenrolling || viewing}
                        />
                    </div>
                ))}
                {selectedQuestionnaires.length >= 1 &&
                    <div style={{position: "relative", display:"flex", flexDirection:"column", width:"300px", paddingTop:"20px"}}>
                        <span className={inputStyles.FloatingLabel}>Notes</span>
                        <textarea className={inputStyles.NoteInput} 
                            id="description"
                            type="text"
                            maxLength={250}
                            disabled={reenrolling || viewing}
                            defaultValue={questionnaireNotes}
                            onChange={e => handleNotes(e)}
                        >
                        </textarea>
                        <span style={{fontSize:"10px", color:"#929395", marginLeft:"auto"}}>
                            {count}/250
                        </span>
                    </div>
                }
            </div>
        </div>
    )
}

export default QuestionnaireEnrollment;